<ng-container *transloco="let t;">
     <div class="px-2">
                @switch (data?.status) {
                    @case (PlaybookGuidelineStatusEnum.MET) {
                        <div class="badge badge-light-success font-small-3">{{ t("Guideline status badge text (Template/Legal hub tab - section) - GUIDELINE MET") }}</div>
                    }
                    @case (PlaybookGuidelineStatusEnum.NOT_MET) {
                        <div class="badge badge-light-danger font-small-3">{{ t("Guideline status badge text (Template/Legal hub tab - section) - GUIDELINE NOT MET") }}</div>
                    }
                    @default {
                        <div class="badge badge-light-secondary font-small-3">{{ t("Guideline status badge text (Template/Legal hub tab - section) - GUIDELINE MISSING") }}</div>
                    }

                }

                @if (data?.guideLineContent){
                   <p class="title fw-bold text-dark font-small-3 pt-75"><strong>{{data.guideLineContent}}</strong></p>
                }

                <div class="section border-top pt-1">
                    <h4 class="fw-normal font-medium-1">{{ t('Playbooks run details header (Playbook run details view) - Reason') }}</h4>
                    <p class="font-small-3 fw-bold text-dark" [innerHtml]="reason" ></p>
                </div>
                @if (data?.reference){
                <div class="section border-top pt-1">
                    <h4 class="fw-normal font-medium-1"> {{ t('Playbooks run details header (Playbook run details view) - Reference in document') }}</h4>
                    <p class="font-small-3 fw-bold text-dark" [innerHtml]="reference"></p>
                </div>
                }

                @if (data?.suggestion){
                <div class="section border-top pt-1">
                    <h4 class="fw-normal font-medium-1">{{ t('Playbooks run details header (Playbook run details view) - Suggestions') }}</h4>
                    <p class="font-small-2 fw-bolder text-dark" [innerHtml]="suggestion"></p>
                </div>
                }
    
                <button type="button" class="btn font-small-3 px-1 btn-success me-50 hidden" rippleEffect>
                    {{ t('Apply Suggestions button text (Template/Legal hub tab - section) - Apply Suggestions') }}
                </button>
            </div>
</ng-container>